export default __webpack_public_path__ + "static/media/0x546b4c391520e6652897c65153074088bfc0a909.ef49361a.webp";